import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexView, Row, Button } from '@cuemath/comps';
import { openModal } from 'actions/modal';
import { MODAL_FORM } from 'constants/form';
import { STUDENT_PAYMENTS_HEADINGS } from 'constants/student-payments';
import MODAL from 'constants/modal';

const FullFlexView = styled(FlexView)`
  width: 100%;
  margin-top: 30px;
`;

const Head = styled(Row)`
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
`;

const ButtonWrapper = styled(Button)`
  margin-left: 20px;
`;

class StudentPayment extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      openModal: PropTypes.func.isRequired,
    }),
  };

  onClickStudentPayments = heading => {
    const { actions } = this.props;

    actions.openModal(
      MODAL_FORM.STUDENT_PAYMENT_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      {
        heading,
      },
    );
  };

  render() {
    const { MODIFY_PAYMENTS, UPLOAD_PAYMENTS } = STUDENT_PAYMENTS_HEADINGS;

    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <Head alignItems="center" justifyContent="center">
          <Button
            label={MODIFY_PAYMENTS}
            onClick={() => this.onClickStudentPayments(MODIFY_PAYMENTS)}
          />
          <ButtonWrapper
            label={UPLOAD_PAYMENTS}
            onClick={() => this.onClickStudentPayments(UPLOAD_PAYMENTS)}
          />
        </Head>
      </FullFlexView>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators(
    {
      openModal,
    },
    dispatch,
  ),
}))(StudentPayment);
